import PerfilTemplate from "../components/templates/PerfilTemplate"

const Perfil = () => {
    return <PerfilTemplate/>
};

export default Perfil;